import { useEffect, useState } from "react";
import { EnviaDatosANuevoServicio } from "../Funciones/Funciones";
import useToken from "../components/login/useToken";
import classes from "./TodosLosRecordatorios.module.css";

function TodosLosRecordatoriosPage(props) {
  const [isLoading, setIsLoading] = useState(false);
  const token = useToken().token;
  const idUsu = token.Id;
  const [loadedRecordatorios, setLoadedRecordatorios] = useState([]);
  const [recarga, setRecarga] = useState(false);

  function eliminaRecordatorio(ev) {
    ev.preventDefault();
    const datos = {
      IDRec: ev.target.id,
    };
    EnviaDatosANuevoServicio(
      "EliminaRecordatorio",
      datos,
      respServ2,
      setIsLoading,
      null,
      idUsu,
    );
  }

  function respServ2(resp) {
    if (resp.Error === "SI") {
      alert(resp.DESCERROR);
    } else {
      setRecarga(true);
    }
  }

  function respServ(resp) {
    setLoadedRecordatorios(resp.recordatorios);
  }

  useEffect(() => {
    setIsLoading(true);
    setRecarga(false);
    const datos = {
      IDCasa: props.casaSel,
    };
    EnviaDatosANuevoServicio(
      "ObtenRecordatorios",
      datos,
      respServ,
      setIsLoading,
      null,
      idUsu,
    );
  }, [props.casaSel, idUsu, recarga]);

  /***********************************************************************/
  /************************ RENDER ***************************************/
  /***********************************************************************/
  if (isLoading) {
    return (
      <section>
        <h1>Cargando estudiantes...</h1>
        <h1>
          <i className="fas fa-spinner fa-spin"></i>
        </h1>
      </section>
    );
  }
  //console.log(loadedRecordatorios);
  if (loadedRecordatorios.length > 0) {
    return (
      <div className={classes.contTabla}>
        <h1>Recordatorios</h1>
        <table>
          <tbody>
            {loadedRecordatorios.map((recordatorio) => {
              return (
                <tr key={recordatorio.IDRec}>
                  <td className={classes.tablecol1}>
                    {recordatorio.Nombre === undefined
                      ? recordatorio.Habitacion
                      : recordatorio.Nombre}
                  </td>
                  <td className={classes.tablecol1}>
                    {recordatorio.Descripcion}
                  </td>
                  <td className={classes.tablecol2}>
                    {props.nivel === 1 ? (
                      <button
                        onClick={eliminaRecordatorio}
                        id={parseInt(recordatorio.IDRec)}
                        className={classes.innbtn}
                      >
                        <i
                          id={parseInt(recordatorio.IDRec)}
                          className="fas fa-times"
                        ></i>
                      </button>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return null;
  }
}

export default TodosLosRecordatoriosPage;
